
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","width":"189","height":"183","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"alert-Page-1","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('g',{attrs:{"id":"alert-Icon-/-Alert","transform":"translate(-6 -5)","fill":"#192638"}},[_c('g',{attrs:{"id":"alert-Group","transform":"translate(4.674 4.82)"}},[_c('ellipse',{attrs:{"id":"alert-Oval","cx":"95.826","cy":"151.846","rx":"7.012","ry":"7.231"}}),_c('path',{attrs:{"d":"M98.082.943a4.75 4.75 0 011.837 1.894l88.765 166.047c2.492 4.663.847 10.527-3.674 13.098a9.127 9.127 0 01-4.514 1.197H11.155c-5.163 0-9.35-4.316-9.35-9.64 0-1.628.4-3.23 1.163-4.655L91.732 2.837c1.246-2.331 4.09-3.18 6.35-1.894zM95.826 20.14L15.108 171.128h161.43L95.827 20.14z","id":"alert-Triangle","fill-rule":"nonzero"}}),_c('path',{attrs:{"d":"M95.826 49.41c3.025 0 5.513 2.371 5.812 5.41l.03.616v72.308c0 3.327-2.615 6.025-5.842 6.025-3.026 0-5.514-2.37-5.813-5.41l-.03-.615V55.436c0-3.328 2.616-6.026 5.843-6.026z","id":"alert-Line","fill-rule":"nonzero"}})])])])])
          )
        }
      }
    